import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const usePaginatedEmails = ({
  patientId,
  startDate,
  endDate,
  page = 1,
  rows = 20,
}) => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: [
      "paginatedEmails",
      tenantVal,
      patientId,
      startDate,
      endDate,
      page,
      rows,
    ],
    queryFn: async () => {
      const axiosInstance = await createAxiosInstance();
      const params = new URLSearchParams({ page, rows });

      if (patientId) params.set("patientId", patientId);
      if (startDate) params.set("startDate", startDate);
      if (endDate) params.set("endDate", endDate);

      const response = await axiosInstance.get(
        `${tenantVal}/patientemail/page?${params}`
      );

      return response.data;
    },
    enabled: !!tenantVal,
  });
};